export const SET_USER = 'SET_USER';
export const RESET_USER = 'RESET_USER';
export const SET_ERROR = 'SET_ERROR';
export const RESET_ERROR = 'RESET_ERROR';


const initialState = {
  clinician: null,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_USER:
      return {
        ...state,
        clinician: action.payload,
      };
    case RESET_USER:
      return {
        clinician: null,
        error: null,
      };
    case SET_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case RESET_ERROR:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};




// WEBPACK FOOTER //
// ./src/reducers/clinician.js